import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-bold font-heading text-primary-400 whitespace-nowrap cursor-pointer">
              非麻瓜漫画
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              非麻瓜漫画提供海量免费韩漫在线观看，支持下拉式阅读体验，每日更新最新韩国漫画全集。无需注册即可免费阅读热门韩漫。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 非麻瓜漫画 feimagua.com - 免费韩漫在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}